import brand from './app/model/branding';
import { isProduction } from 'utils';
export const is_sentry_enabled = isProduction() && !!SENTRY_ENABLED && !!SENTRY_DSN && !!UI_VERSION;
export const load_sentry = () => {
    return import(
    // webpackChunkName: 'sentry'
    '@sentry/browser');
};
export const with_sentry = async (callback) => {
    if (is_sentry_enabled) {
        const Sentry = await load_sentry();
        callback(Sentry);
    }
};
export const initSentry = () => {
    with_sentry((Sentry) => {
        Sentry.init({
            dsn: SENTRY_DSN,
            release: `zont-ui@${UI_VERSION}`,
            sendDefaultPii: true,
            ignoreErrors: [
                'Non-Error promise rejection captured',
                'e.preventDefault is not a function',
                'ChunkLoadError',
                'ResizeObserver loop completed',
            ],
        });
        Sentry.configureScope((scope) => {
            scope.setTag('brand', brand.code);
        });
    }).then();
};
